if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        document.dispatchEvent(new CustomEvent("alert:clear"));

        evt.preventDefault();

        // Read custom data from the submit button's dataset
        const customParam = this.submitButton.dataset.customParam;
        const selectedOption = this.submitButton.dataset.selectedOption;
        // Clear the custom data after reading it

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        const productCard = this.closest("product-card");
        if (
          productCard &&
          productCard.classList.contains("product-card-wrapper--expandable") &&
          !productCard.classList.contains("product-card-wrapper--expanded")
        ) {
          productCard.classList.add("product-card-wrapper--expanded");
          return;
        }

        if (this.submitButton.classList.contains("has-size-select") && !customParam) {
          const quickAdd = this.closest(".quick-add");
          const sizeSelect = quickAdd.querySelector(".quick-add__size-select");
          if (sizeSelect) {
            sizeSelect.classList.add("active");
            document.body.addEventListener(
              "click",
              (event) => {
                if (!event.target.closest(".quick-add__size-select")) {
                  sizeSelect.classList.remove("active");
                }
              },
              { once: true }
            );
            return;
          }
        } else if (this.submitButton.classList.contains("has-shade-select")) {
          const productCard = this.closest("product-card");
          const variantSelects = productCard.querySelector("variant-selects");

          if (
            productCard.classList.contains("product-card-wrapper--expandable")
          ) {
            productCard.classList.add("product-card-wrapper--expanded");
          }

          if (
            variantSelects &&
            (variantSelects.classList.contains("hidden") ||
              variantSelects.classList.contains("ugc-shades"))
          ) {
            variantSelects.classList.remove("hidden");
            return;
          }
        } else if (
          this.submitButton.classList.contains("has-size-select--ugc")
        ) {
          const productCard = this.closest("product-card");
          if (
            productCard.classList.contains(
              "product-card-wrapper--expandable"
            ) &&
            !productCard.classList.contains("product-card-wrapper--expanded")
          ) {
            productCard.classList.add("product-card-wrapper--expanded");
            return;
          }
        }

        // Dataset in place to update quick select
        if (customParam) delete this.submitButton.dataset.customParam;
        if (selectedOption) delete this.submitButton.dataset.selectedOption;

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append("sections", ["cart-drawer"]);
        }

        let productGroup =
          this.closest(".product")?.querySelector("product-group");

        if (productGroup) {
          let productGroupCurrent = productGroup.dataset.selectedType;
          let productGroupCurrentItem = productGroupCurrent.split(":");
          let productGroupType = productGroupCurrentItem[0].trim();
          let productGroupData = productGroupCurrentItem[1].trim();

          formData.set(`[properties][${productGroupType}]`, productGroupData);
        }

        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.error();
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });

            this.error = false;

            document.dispatchEvent(
              new CustomEvent("cart:repaint", {
                detail: {
                  data: response,
                },
              })
            );
          })
          .catch((e) => {
            console.error(e);
            this.error();
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            if (this.closest(".quick-add__size-select")) {
              this.closest(".quick-add__size-select").classList.remove(
                "active"
              );
            }
          });
      }

      error() {
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.error = true;
      }

      handleErrorMessage() {
        document.dispatchEvent(
          new CustomEvent("alert:show", {
            detail: {
              data: {
                message: `${cartStrings.error}`,
                status: "Error",
              },
            },
          })
        );
      }
    }
  );
}
